<template>
  <div class="w-screen h-screen">
    <nav
      class="bg-nav-color w-full h-auto fixed px-4 py-2 z-20 border-b-4 border-gray-400"
    >
      <div class="flex items-center justify-end">
        <div class="flex w-6/12">
          <div class="flex items-center justify-center w-48">
            <img
              src="@/assets/logos-instituciones/CONAHCYT.svg"
              class="h-12 md:h-16"
            />
          </div>
          <div class="flex items-center justify-center w-48">
            <img
              src="@/assets/logos-instituciones/centrogeo.png"
              class="h-12 md:h-16"
            />
          </div>
          <div class="flex items-center justify-center w-48">
            <img
              src="@/assets/logos-instituciones/geoint.png"
              class="h-12 md:h-16"
            />
          </div>
          <div class="flex items-center justify-center w-48">
            <img
              src="@/assets/logos-instituciones/gob-yucatan.png"
              class="h-12 md:h-16"
            />
          </div>
          <div class="flex items-center justify-center w-48">
            <img
              src="@/assets/logo-plataforma_web_light_128.png"
              class="h-12 md:h-16"
            />
          </div>
        </div>
        <div class="flex w-6/12 items-center justify-end">
          <div class="relative group">
            <div
              data-v-step="notifications"
              class="flex w-full justify-end px-2 py-2 cursor-pointer"
            >
              <a
                v-on:click="showDropdown"
                href="#"
                class="flex items-center justify-center px-2 py-2 text-gray-800 bg-primary-color text-white rounded-full"
              >
                <svg
                  class="h-6 w-6"
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 122.88 122.83"
                >
                  <path
                    d="M73.81,7.47A43.14,43.14,0,0,1,92.69,19.35a42.33,42.33,0,0,1,10.76,21.36l0,.28c.21,1.21.36,2.36.45,3.44.11,1.26.17,2.53.17,3.8h0V58.36c0,2.81,0,5.67.2,8.54a32.41,32.41,0,0,0,4.34,14.62A36.6,36.6,0,0,0,120,92.83a6.34,6.34,0,0,1,2.65,3.65,6.52,6.52,0,0,1-.08,3.56,6.62,6.62,0,0,1-1.91,3,6.33,6.33,0,0,1-4.25,1.57H82.27l0,.08h0c-4.14,24.2-37.61,24.13-41.65-.08H6.45A6.33,6.33,0,0,1,2,102.92a6.6,6.6,0,0,1-1.81-6.5A6.33,6.33,0,0,1,3,92.71c5.66-3.83,9.62-8,12.12-12.76s3.65-10.44,3.65-17.28V48.23c0-1.16.06-2.42.18-3.77s.29-2.52.51-3.76A42.89,42.89,0,0,1,49.39,7.41C54-2.47,69.2-2.49,73.81,7.47ZM87.71,24A36.34,36.34,0,0,0,70.38,13.57,3.42,3.42,0,0,1,68,11.22c-1.71-5.87-11-6-12.72-.05a3.43,3.43,0,0,1-2.48,2.38A36.1,36.1,0,0,0,26.15,41.9q-.28,1.58-.42,3.15c-.09,1-.13,2-.13,3.18V62.67c0,7.91-1.38,14.56-4.45,20.43-2.94,5.62-7.36,10.39-13.54,14.72H115.27A42.38,42.38,0,0,1,102.8,85,39.18,39.18,0,0,1,97.5,67.4c-.22-2.88-.21-6-.2-9V48.23h0c0-1.1,0-2.17-.13-3.22s-.21-2-.36-2.85l-.06-.27a35.62,35.62,0,0,0-9-17.9Z"
                  />
                </svg>
                <div
                  v-if="
                    raising.length > 0 ||
                    curator_raising.length > 0 ||
                    projects.length > 0 ||
                    curator_projects.length > 0 ||
                    listDownload.length > 0
                  "
                  class="font-bold text-gray-700 rounded-full flex items-center justify-center w-2 h-2 bg-white"
                ></div>
              </a>
            </div>
            <div
              id="dropdown"
              class="absolute right-0 mt-14 mt-0 py-2 w-64 bg-white rounded-lg shadow-xl text-left hidden"
            >
              <ul
                class="py-1 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownDefault"
                v-if="raising.length > 0 || curator_raising.length > 0"
              >
                <span class="pl-5">LEVANTAMIENTOS</span>
                <router-link
                  v-for="one_raising in raising"
                  :key="one_raising.id"
                  :to="{
                    name: 'viewRaising',
                    query: { id: one_raising.id, name: one_raising.title },
                  }"
                  @click.native="updateListRaising(one_raising.id)"
                  class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left hover:bg-primary-color text-gray-900 hover:text-white"
                >
                  <div class="flex flex-col ml-2">
                    <span>{{ one_raising.title }}</span>
                    <span>{{
                      one_raising.fecha_levantamiento
                        | moment("DD/MM/YYYY hh:mm A")
                    }}</span>
                    <span class="text-sm"
                      >F-{{ one_raising.id }} {{ one_raising.status }}</span
                    >
                    <span class="text-xs">{{ one_raising.cat_principal }}</span>
                    <span class="text-xs">{{
                      one_raising.cat_secundaria
                    }}</span>
                  </div>
                </router-link>

                <router-link
                  v-for="one_raising in curator_raising"
                  :key="one_raising.id"
                  :to="{
                    name: 'viewRaisingEvaluation',
                    query: { id: one_raising.id, name: one_raising.title },
                  }"
                  @click.native="updateListRaising(one_raising.id)"
                  class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left hover:bg-primary-color text-gray-900 hover:text-white"
                >
                  <div class="flex flex-col ml-2">
                    <span>{{ one_raising.title }}</span>
                    <span>{{
                      one_raising.fecha_levantamiento
                        | moment("DD/MM/YYYY hh:mm A")
                    }}</span>
                    <span class="text-sm"
                      >F-{{ one_raising.id }} {{ one_raising.status }}</span
                    >
                    <span class="text-xs">{{ one_raising.cat_principal }}</span>
                    <span class="text-xs">{{
                      one_raising.cat_secundaria
                    }}</span>
                  </div>
                </router-link>
              </ul>
              <ul
                class="py-1 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownDefault"
                v-if="projects.length > 0 || curator_projects.length > 0"
              >
                <span class="pl-5">PROYECTOS</span>
                <router-link
                  v-for="one_project in projects"
                  :key="one_project.id"
                  :to="{
                    name: 'viewProject',
                    query: { id: one_project.id, name: one_project.title },
                  }"
                  @click.native="updateListProject(one_project.id)"
                  class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left hover:bg-primary-color text-gray-900 hover:text-white"
                >
                  <div class="flex flex-col ml-2">
                    <span>{{ one_project.title }}</span>
                    <span>{{
                      one_project.fecha_creacion | moment("DD/MM/YYYY hh:mm A")
                    }}</span>
                    <span class="text-sm"
                      >F-{{ one_project.id }} {{ one_project.status }}</span
                    >
                    <span class="text-xs">{{ one_project.cat_principal }}</span>
                    <span class="text-xs">{{
                      one_project.cat_secundaria
                    }}</span>
                  </div>
                </router-link>

                <router-link
                  v-for="one_project in curator_projects"
                  :key="one_project.id"
                  :to="{
                    name: 'viewProjectEvaluation',
                    query: { id: one_project.id, name: one_project.title },
                  }"
                  @click.native="updateListProject(one_project.id)"
                  class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left hover:bg-primary-color text-gray-900 hover:text-white"
                >
                  <div class="flex flex-col ml-2">
                    <span>{{ one_project.title }}</span>
                    <span>{{
                      one_project.fecha_creacion | moment("DD/MM/YYYY hh:mm A")
                    }}</span>
                    <span class="text-sm"
                      >F-{{ one_project.id }} {{ one_project.status }}</span
                    >
                    <span class="text-xs">{{ one_project.cat_principal }}</span>
                    <span class="text-xs">{{
                      one_project.cat_secundaria
                    }}</span>
                  </div>
                </router-link>
              </ul>
              <ul
                class="py-1 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownDefault"
                v-if="listDownload.length > 0"
              >
                <span class="pl-5">Descargas</span>
                <router-link
                  v-for="one_download in listDownload"
                  :key="one_download.id"
                  :to="{
                    name: 'viewDownload',
                    query: { id: one_download.id, name: one_download.title },
                  }"
                  @click.native="updateListDownload(one_download.id)"
                  class="group flex items-center cursor-pointer my-1 py-2 px-5 text-left hover:bg-primary-color text-gray-900 hover:text-white"
                >
                  <div class="flex flex-col ml-2">
                    <span>{{ one_download.title }}</span>
                    <span>{{
                      one_download.fecha_solicitud
                        | moment("DD/MM/YYYY hh:mm A")
                    }}</span>
                    <span class="text-sm"
                      >F-{{ one_download.id }} {{ one_download.status }}</span
                    >
                  </div>
                </router-link>
              </ul>
              <span
                class="flex items-center my-1 py-2 px-10 text-left text-gray-900"
                v-if="
                  raising.length == 0 &&
                  curator_raising.length == 0 &&
                  projects.length == 0 &&
                  listDownload.length == 0 &&
                  curator_projects.length == 0
                "
              >
                No hay notificaciones
              </span>
            </div>
          </div>

          <div class="relative group">
            <div class="flex items-center px-2 py-2 cursor-pointer">
              <img
                class="h-8 w-8 rounded-full"
                :src="profile_image"
                @error="defaultProfile"
              />
              <span class="ml-2 text-white font-bold"
                >{{ user }}
                <br />
                <span
                  class="ml-2 text-white"
                  style="font-weight: normal; font-size: 14px"
                  >{{ category }}</span
                >
              </span>
              <span class="text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path d="M7 10l5 5 5-5z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </span>
            </div>
            <div
              class="absolute right-0 mt-0 py-2 w-48 bg-white rounded-lg shadow-xl text-left hidden group-hover:block"
            >
              <a
                v-on:click="updateProfileModal"
                href="#"
                class="flex items-center justify-center px-4 py-2 text-gray-800 hover:bg-primary-color hover:text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                  />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
                <span class="ml-2 font-bold">Perfil</span>
              </a>
              <a
                @click="dologout"
                href="#"
                class="flex items-center justify-center px-4 py-2 text-gray-800 hover:bg-primary-color hover:text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                  />
                </svg>
                <span class="ml-2 font-bold">Cerrar sesión</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="flex">
      <div class="w-56 h-screen bg-white pt-20" style="overflow-y: auto">
        <div class="separator_menu">Consulta</div>
        <ul class="flex flex-row md:flex-col items-center md:items-stretch">
          <li class="text-left">
            <router-link
              data-v-step="map"
              to="/explorer"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide">Mapa</span>
            </router-link>
          </li>

          <li class="text-left">
            <router-link
              to="/gallery"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 -960 960 960"
              >
                <path
                  d="M360-400h400L622-580l-92 120-62-80-108 140Zm-40 160q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Z"
                />
              </svg>

              <span class="ml-2 tracking-wide">Galería</span>
            </router-link>
          </li>

          <li class="text-left">
            <router-link
              to="/users"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 -960 960 960"
              >
                <path
                  d="M160-40v-80h640v80H160Zm0-800v-80h640v80H160Zm320 400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm70-80q45-56 109-88t141-32q77 0 141 32t109 88h70v-480H160v480h70Zm118 0h264q-29-20-62.5-30T480-280q-36 0-69.5 10T348-240Zm132-280q-17 0-28.5-11.5T440-560q0-17 11.5-28.5T480-600q17 0 28.5 11.5T520-560q0 17-11.5 28.5T480-520Zm0 40Z"
                />
              </svg>

              <span class="ml-2 tracking-wide">Usuarios</span>
            </router-link>
          </li>

          <li class="text-left">
            <router-link
              to="/explora"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 -960 960 960"
              >
                <path
                  d="m720-430 80 80v190q0 33-23.5 56.5T720-80H160q-33 0-56.5-23.5T80-160v-560q0-33 23.5-56.5T160-800h220q-8 18-12 38.5t-6 41.5H160v560h560v-270Zm52-174 128 128-56 56-128-128q-21 12-45 20t-51 8q-75 0-127.5-52.5T440-700q0-75 52.5-127.5T620-880q75 0 127.5 52.5T800-700q0 27-8 51t-20 45Zm-152 4q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM160-430v270-560 280-12 22Z"
                />
              </svg>

              <span class="ml-2 tracking-wide">Explora y únete</span>
            </router-link>
          </li>

          <!-- <li class="text-left">
            <router-link
              data-v-step="new"
              to="/mapa"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18 8H20V5H23V3H20V0H18V3H15V5H18ZM12 12Q12.825 12 13.413 11.412Q14 10.825 14 10Q14 9.175 13.413 8.587Q12.825 8 12 8Q11.175 8 10.588 8.587Q10 9.175 10 10Q10 10.825 10.588 11.412Q11.175 12 12 12ZM12 22Q7.975 18.575 5.988 15.637Q4 12.7 4 10.2Q4 6.45 6.413 4.225Q8.825 2 12 2Q12.25 2 12.5 2.012Q12.75 2.025 13 2.05V4.075Q12.75 4.025 12.512 4.012Q12.275 4 12 4Q9.475 4 7.737 5.737Q6 7.475 6 10.2Q6 11.975 7.475 14.262Q8.95 16.55 12 19.35Q15.05 16.55 16.525 14.262Q18 11.975 18 10.2Q18 10.15 18 10.1Q18 10.05 18 10H20Q20 10.05 20 10.1Q20 10.15 20 10.2Q20 12.7 18.013 15.637Q16.025 18.575 12 22ZM12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Q12 10.075 12 10.075Z"
                />
              </svg>
              <span class="ml-2 tracking-wide">Crear nuevo</span>
            </router-link>
          </li> -->

          <!-- <li class="text-left">
            <router-link
              to="/cuestionarios"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Encuestas</span>
            </router-link>
          </li> -->

          <!-- <li class="text-left" v-if="category == 'true'">
            <router-link
              to="/monitorsList"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
                />
                <path fill="none" d="M0 0h24v24H0z" />
              </svg>

              <span class="ml-2 tracking-wide font-bold">Monitoristas</span>
            </router-link>
          </li> -->
          <!-- <li class="text-left" v-if="category == 'true'">
            <router-link
              to="/lugares"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Lugares de interés</span>
            </router-link>
          </li> -->
          <!-- <li class="text-left" v-if="category == 'true'">
            <router-link
              to="/eventos"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Eventos</span>
            </router-link>
          </li> -->

          <!-- <li class="text-left">
            <router-link
              data-v-step="statistics"
              to="/estadisticasUser"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <g>
                  <rect fill="none" height="24" width="24" />
                  <g>
                    <path
                      d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z"
                    />
                    <rect height="5" width="2" x="7" y="12" />
                    <rect height="10" width="2" x="15" y="7" />
                    <rect height="3" width="2" x="11" y="14" />
                    <rect height="2" width="2" x="11" y="10" />
                  </g>
                </g>
              </svg>
              <span class="ml-2 tracking-wide">Mis Estadísticas</span>
            </router-link>
          </li> -->

          <div class="separator_menu">Mis actividades</div>
          <li class="text-left">
            <router-link
              data-v-step="projects"
              to="/proyectos"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                />
              </svg>
              <span class="ml-2 tracking-wide">Mis propuestas de registro</span>
            </router-link>
          </li>

          <li class="text-left">
            <router-link
              data-v-step="fichas"
              to="/userRaising"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M3 19V5H21V19ZM5 9H7V7H5ZM9 9H19V7H9ZM9 13H19V11H9ZM9 17H19V15H9ZM5 17H7V15H5ZM5 13H7V11H5Z"
                />
              </svg>
              <span class="ml-2 tracking-wide">Mis fichas</span>
            </router-link>
          </li>

          <li class="text-left">
            <router-link
              data-v-step="downloads"
              to="/download"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                />
              </svg>
              <span class="ml-2 tracking-wide">Mis descargas</span>
            </router-link>
          </li>

          <div v-if="category == 'ADMINISTRADOR'" class="separator_menu">
            Administración
          </div>
          <div v-if="category == 'REVISOR'" class="separator_menu">
            Revisión
          </div>

          <li class="text-left" v-if="category == 'ADMINISTRADOR'">
            <router-link
              to="/userList"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
                />
                <path fill="none" d="M0 0h24v24H0z" />
              </svg>

              <span class="ml-2 tracking-wide">Usuarios</span>
            </router-link>
          </li>
          <li class="text-left" v-if="category == 'ADMINISTRADOR'">
            <router-link
              to="/guestUserList"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>

              <span class="ml-2 tracking-wide">Invitaciones</span>
            </router-link>
          </li>

          <li
            class="text-left"
            v-if="category == 'REVISOR' || category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/raising"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
              </svg>
              <span class="ml-2 tracking-wide">Revisión de fichas</span>
            </router-link>
          </li>

          <li class="text-left" v-if="category == 'ADMINISTRADOR'">
            <router-link
              to="/estadisticas"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <g>
                  <rect fill="none" height="24" width="24" />
                  <g>
                    <path
                      d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z"
                    />
                    <rect height="5" width="2" x="7" y="12" />
                    <rect height="10" width="2" x="15" y="7" />
                    <rect height="3" width="2" x="11" y="14" />
                    <rect height="2" width="2" x="11" y="10" />
                  </g>
                </g>
              </svg>
              <span class="ml-2 tracking-wide">Estadísticas</span>
            </router-link>
          </li>

          <li class="text-left" v-if="category == 'ADMINISTRADOR'">
            <router-link
              to="/proyectosTodos"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                />
              </svg>
              <span class="ml-2 tracking-wide">Proyectos</span>
            </router-link>
          </li>

          <li
            class="text-left"
            v-if="category == 'REVISOR' || category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/projectEvaluation"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
              </svg>
              <span class="ml-2 tracking-wide">Revisión de proyectos</span>
            </router-link>
          </li>

          <li
            class="text-left"
            v-if="category == 'REVISOR' || category == 'ADMINISTRADOR'"
          >
            <router-link
              to="/downloadEvaluation"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
              </svg>
              <span class="ml-2 tracking-wide">Revisión de descargas</span>
            </router-link>
          </li>

          <!-- <li class="text-left">
            <router-link
              to="/quejas"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Denuncias</span>
            </router-link>
          </li> -->
          <!-- <li class="text-left" v-if="category == 'true'">
            <router-link
              to="/reportes"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-activity"
              >
                <rect x="10" y="3" width="4" height="18" />
                <rect x="18" y="8" width="4" height="13" />
                <rect x="2" y="13" width="4" height="8" />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Reportes</span>
            </router-link>
          </li> -->
          <!-- <li class="text-left" v-if="category == 'true'">
            <router-link
              to="/configuracion"
              class="px-5 py-3 flex flex-col md:flex-row items-center text-gray-900 hover:bg-primary-color hover:text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
                viewBox="0 0 24 24"
              >
                <path
                  d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                />
              </svg>
              <span class="ml-2 tracking-wide font-bold">Configuración</span>
            </router-link>
          </li> -->
        </ul>
      </div>
      <div class="flex-1 h-screen bg-brd-color pt-20">
        <keep-alive include="Map">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </div>
    </div>

    <profile-modal
      :showing="showProfileModal"
      @close="closeProfileModal"
    ></profile-modal>

    <loading-page v-if="isLoading"></loading-page>

    <v-tour
      name="myTour"
      :steps="steps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Router from "vue-router";
import Map from "./Map";
import FormList from "./FormList";
import FormBuilder from "./FormBuilder";
import FormEditBuilder from "./FormEditBuilder";
import UserList from "./UserList";
import MonitorsList from "./MonitorsList";
import PlacesList from "./PlacesList";
import profileModal from "./ProfileModal";
import AlertList from "./AlertList";
import EventBus from "../event-bus";
import LoadingPage from "./LoadingPage";

export default {
  name: "dashboard",
  data() {
    return {
      raising: [],
      curator_raising: [],
      projects: [],
      curator_projects: [],
      listDownload: [],
      user: localStorage.getItem("name"),
      category: localStorage.getItem("category"),
      profile_image: localStorage.getItem("profile_image"),
      showProfileModal: false,
      isLoading: false,
      steps: [
        {
          target: '[data-v-step="map"]',
          content:
            "Selecciona esta pestaña para consultar en el mapa los registros públicos realizados por todos los usuarios.",
          params: {
            placement: "right",
          },
        },
        /* {
          target: '[data-v-step="new"]',
          content: "Selecciona esta pestaña para añadir un nuevo registro.",
          params: {
            placement: "right",
          },
        },
        {
          target: '[data-v-step="selectMunicipio"]',
          content: "Aquí puedes seleccionar un municipio.",
          params: {
            placement: "right",
          },
        }, */
        {
          target: '[data-v-step="fichas"]',
          content: "Revisa las fichas de registro que has aportado.",
          params: {
            placement: "right",
          },
        },
        {
          target: '[data-v-step="newRegister"]',
          content: "Dando clic aquí puedes agregar un nuevo registro.",
          params: {
            placement: "right",
          },
          offset: -200,
        },
        /* {
          target: '[data-v-step="statistics"]',
          content: "Revisa las estadísticas de tus registros.",
          params: {
            placement: "right",
          },
        }, */
        {
          target: '[data-v-step="projects"]',
          content: "Crea y revisa tus propios proyectos.",
          params: {
            placement: "right",
          },
        },
        {
          target: '[data-v-step="downloads"]',
          content: "En esta parte puedes ver las descargas que has solicitado.",
          params: {
            placement: "right",
          },
        },
        {
          target: '[data-v-step="notifications"]',
          content:
            "En esta sección puedes revisar las notificaciones sobre el estado de tus fichas y/o mensajes de los revisores.",
          params: {
            placement: "bottom",
          },
        },
      ],
      tourOptions: {
        labels: {
          buttonSkip: "Saltar",
          buttonPrevious: "Anterior",
          buttonNext: "Siguiente",
          buttonStop: "Salir",
        },
      },
      tourCallbacks: {
        onStart: this.onStartTour,
        onPreviousStep: this.onPreviousTour,
        onNextStep: this.onNextTour,
        onFinish: this.onFinishTour,
        onSkip: this.onFinishTour,
      },
    };
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"]),
  },
  components: {
    profileModal,
    LoadingPage,
  },
  methods: {
    ...mapActions(["logout"]),
    dologout: function () {
      this.logout({});
    },
    getProfileImage: function () {
      //if (this.profile_image == null) {
      if (this.profile_image.includes("null")) {
        this.profile_image =
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
      }
    },
    updateProfileModal: function () {
      this.showProfileModal = true;
    },
    closeProfileModal: function () {
      this.showProfileModal = false;
      this.profile_image = localStorage.getItem("profile_image");
    },
    defaultProfile: function () {
      this.profile_image =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    showDropdown() {
      if (document.querySelector("#dropdown").classList.contains("block")) {
        document.querySelector("#dropdown").classList.remove("block");
        document.querySelector("#dropdown").classList.add("hidden");
      } else {
        document.querySelector("#dropdown").classList.add("block");
        document.querySelector("#dropdown").classList.remove("hidden");
      }
    },
    fetchNotifications() {
      this.axios
        .post(
          "../apidev/levantamientos/getNotifications",
          {
            email: localStorage.getItem("email"),
          },
          this.config
        )
        .then((response) => {
          this.raising = response.data.levantamientos;
          return this.axios.post(
            "../apidev/levantamientos/getCuratorNotifications",
            {
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.curator_raising = response.data.levantamientos;
          console.log("this.curator_raising", this.curator_raising);
          return this.axios.post(
            "../apidev/projects/getNotifications",
            {
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.projects = response.data.projects;
          return this.axios.post(
            "../apidev/projects/getCuratorNotifications",
            {
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.curator_projects = response.data.projects;
          return this.axios.post(
            "../apidev/downloads/getNotifications",
            {
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.listDownload = response.data.list;
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    updateListRaising(id) {
      this.axios
        .post(
          "../apidev/levantamientos/updateNotification",
          {
            id_levantamiento: id,
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch((error) => this.catchError(error));

      this.showDropdown();
    },
    updateListProject(id) {
      this.axios
        .post(
          "../apidev/projects/updateNotification",
          {
            id: id,
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch((error) => this.catchError(error));

      this.showDropdown();
    },
    updateListDownload(id) {
      this.axios
        .post(
          "../apidev/downloads/updateNotification",
          {
            id: id,
          },
          this.config
        )
        .then(() => {
          this.fetchNotifications();
        })
        .catch((error) => this.catchError(error));

      this.showDropdown();
    },
    catchError(error) {
      console.log(error);
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
    },
    onStartTour() {
      let currentRoute = this.$route.name;
      if (currentRoute !== "explorer") {
        this.$router.push({ path: "/explorer" });
      }
    },
    onPreviousTour(current) {
      switch (current) {
        case 1:
          this.$router.push({ path: "/explorer" });
          break;
        /* case 4:
          this.$router.push({ path: "/mapa" });
          break; */
        case 3:
          this.$router.push({ path: "/userRaising" });
          break;
        /* case 6:
          this.$router.push({ path: "/estadisticasUser" });
          break; */
        case 4:
          this.$router.push({ path: "/proyectos" });
          break;
        default:
          break;
      }
    },
    onNextTour(current) {
      switch (current) {
        /* case 0:
          this.$router.push({ path: "/mapa" });
          break; */
        case 0:
          this.$router.push({ path: "/userRaising" });
          break;
        /* case 4:
          this.$router.push({ path: "/estadisticasUser" });
          break; */
        case 2:
          this.$router.push({ path: "/proyectos" });
          break;
        case 3:
          this.$router.push({ path: "/download" });
          break;
        default:
          break;
      }
    },
    onFinishTour() {
      localStorage.setItem("tour", "tourFinished");
    },
  },
  mounted() {
    EventBus.$on("updateNotification", this.fetchNotifications);
    this.fetchNotifications();
    this.getProfileImage();

    this.$root.$on("showLoading", () => {
      this.isLoading = true;
    });

    this.$root.$on("hideLoading", () => {
      this.isLoading = false;
    });

    let tour = localStorage.getItem("tour");
    if (tour !== "tourFinished") {
      this.$tours["myTour"].start();
    }
  },
};
</script>

<style scoped>
.router-link-active {
  background-color: #7e65aa;
  color: #ffffff;
}

.bg-nav-color {
  background-color: #361e5e;
}

.separator_menu {
  height: 30px;
  font-weight: bold;
  color: white;
  background-color: #361e5e;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}
</style>
